export enum UserAccess {
  Free = 'free',
  Premium = 'premium',
}
